<div class="text-bidit-primary">
  <div class="row mb-3">
    <div class="col-4">
      <button *ngIf="!readOnly" class=" float-left btn btn-bidit-submit float-left" (click)="openAreaDialog(null)" i18n>Add Item</button>
    </div>
    <div class="col-3">
      <button *ngIf="(!readOnly || isQuoteAcknowledged) && canAddJob && quote.quote_Converted === null" (click)="recalcQuote()" class="ml-2 btn btn-bidit-action btn-md" i18n>Refresh</button>
    </div>
    <div class="col-5">
      <button *ngIf="(!readOnly || isQuoteAcknowledged) && canAddJob" (click)="convertQuote()" class=" float-right btn btn-bidit-submit btn-md" i18n>Convert to Job</button>
    </div>
  </div>

  <div class="col mb-2" *ngIf="quote.acknowledgementStatus">
    <span class="col-form-label" i18n>Acknowledgement </span><span class="mr-1">{{quote.acknowledgementStatus}}</span>
    <span *ngIf="this.quote.quoteAcknowledgedDate" class="col-form-label" i18n> on </span><span> {{quote.quoteAcknowledgedDate | date:'MM/dd/yyyy'}}</span>
  </div>
  <div class="col mb-2">
    <label for="quote_roundMaterials" i18n>Round Materials</label>
    <mat-radio-group (change)="materialsRoundingChanged()" name="quote_roundMaterials"
                     [disabled]="readOnly"
                     [(ngModel)]="quote.roundMaterials">
      <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
      <mat-radio-button [value]="false" i18n>No</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="col mb-2">
    <div *ngIf="!quote.quote_IsTemplate" class="form-inline mr-4">
      <label for="lostStatus" class="mr-2" i18n>Quote Status</label>
      <select class="form-control" name="lostStatus" id="lostStatus"
              [disabled]="readOnly"
              [(ngModel)]="lostStatus"
              (change)="quoteStatusChanged()">
        <option value="" i18n>Active</option>
        <option value="L" i18n>Lost</option>
        <option *ngIf="quoteOnly" value="W" i18n>Won</option>
      </select>
    </div>
  </div>
  <div cdkDropList [cdkDropListData]="areaSummaries" (cdkDropListDropped)="dropArea($event)">
    <div cdkDrag [cdkDragDisabled]="area.area_Sort == 99" class="text-bidit-primary mb-5" *ngFor="let area of areaSummaries">
      <div *ngIf="!area.area_IsOption">
        <div class="row">
          <h5 class="col">
            {{area.area_Name}}
          </h5>
          <div class="float-right mr-5">
            <div colspan="5"></div>
            <div *ngIf="showLinePricing"><h5><span i18n>Total</span> ${{area.totalCost | number: '1.2-2'}}</h5></div>
          </div>
        </div>
        <mat-accordion>
          <div cdkDropList [cdkDropListData]="area.quoteAreas" (cdkDropListDropped)="dropItem($event)">
            <div cdkDrag class="text-bidit-primary" *ngFor="let quoteArea of area.quoteAreas">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <div class="col-6">
                    <div id="quoteArea.quoteItem.subArea.subArea_Name">{{quoteArea.quoteItem.subArea.subArea_Name}} <span *ngIf="quoteArea.quoteItem.area_Name"> - {{quoteArea.quoteItem.area_Name}}</span></div>
                  </div>
                  <div class="col-6">
                    <div class="col">
                      <label i18n>Square Ftg:</label>
                      <span>{{quoteArea.quoteItem.area_SqrFtg | number: '1.2' }}</span>
                    </div>
                    <div *ngIf="showLinePricing" class="col">
                      <label *ngIf="area.area_IsOption; else defaultHeader" i18n>Cost Change:</label>
                      <ng-template>
                        <label i18n>Cost:</label>
                      </ng-template>
                      <span>${{quoteArea.quoteItem.area_TotalCost | number: '1.2' }}</span>
                    </div>
                  </div>
                </mat-expansion-panel-header>
                <div *ngIf="quoteArea.quoteItem.item" class="row mt-3">
                  <div class="col-md-6">
                    {{quoteArea.quoteItem.item.item_Name}}
                  </div>
                  <div class="col-md-6">
                    <div class="col">
                      <label class="mr-2">R-Value: </label>
                      <span *ngIf="quoteArea.quoteItem.itemUsage; then usageBlock; else rValueBlock"></span>
                      <ng-template #usageBlock>{{quoteArea.quoteItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                      <ng-template #rValueBlock>
                        <span *ngIf="quoteArea.quoteItem.item && quoteArea.quoteItem.item.rValue">{{quoteArea.quoteItem.item.rValue.rValue_Desc}}</span>
                      </ng-template>
                    </div>
                    <div class="col">
                      <div *ngIf="area.area_IsOption; else defaultAccessoryBlock">
                        <div *ngIf="showLinePricing">
                          <label class="mr-2" i18n>Estimate Change:</label>
                          <span>
                            ${{quoteArea.quoteItem.optionBid | number: '1.2' }}
                          </span>
                        </div>
                      </div>
                      <ng-template #defaultAccessoryBlock>
                        <label class="mr-2" i18n>Addl Items:</label>
                        <span>
                          {{quoteArea.quoteItem.accessories.length}}
                        </span>
                      </ng-template>
                    </div>
                  </div>

                </div>
                <div class="col bidit-alert mt-3" *ngFor="let upgrade of quoteArea.quoteUpgrades">
                  <div class="mr-2" i18n>ALTERNATE</div>
                  <div class="mr-2">
                    <label class="mr-2" i18n>Product:</label>
                    <p *ngIf="upgrade.item.item_Part; then upgradeDom else defaultDom"></p>
                    <ng-template #upgradeDom>{{upgrade.item.item_Part}}, {{upgrade.area_Name}}</ng-template>
                    <ng-template #defaultDom>{{upgrade.area_Name}}</ng-template>
                  </div>

                  <div class="mr-2">
                    <label class="mr-2" i18n>R-Value:</label>
                    <span *ngIf="upgrade.itemUsage; then usageBlock; else rValueBlock"></span>
                    <ng-template #usageBlock>{{upgrade.itemUsage.rValue.rValue_Desc}}</ng-template>
                    <ng-template #rValueBlock>{{upgrade.item.rValue.rValue_Desc}}</ng-template>
                  </div>

                  <div *ngIf="showLinePricing">
                    <span><strong i18n>Estimate Change:</strong>${{upgrade.upgradeBid | number:'1.2-2'}}</span><br>
                    <span><strong i18n>Cost Change:</strong>${{upgrade.upgradeDelta | number:'1.2-2'}}</span>
                    <button *ngIf="!readOnly" class="btn btn-bidit-edit ml-2" (click)="openAreaDialog(upgrade.quoteAreaItem_ID)"></button>
                    <button *ngIf="!readOnly" class="btn btn-bidit-delete" (click)="deleteArea(upgrade.quoteAreaItem_ID)"></button>
                  </div>

                </div>
                <mat-action-row class="float-right mb-3">
                  <button *ngIf="!readOnly" class="btn btn-bidit-edit" (click)="openAreaDialog(quoteArea.quoteItem.quoteAreaItem_ID)"></button>
                  <button *ngIf="!readOnly" class="btn btn-bidit-delete" (click)="deleteArea(quoteArea.quoteItem.quoteAreaItem_ID)"></button>
                  <button *ngIf="!readOnly && !area.area_IsOption" class="btn btn-bidit-add" (click)="addUpgradeDialog(quoteArea)" title="Add alternate to product" i18n-title></button>
                </mat-action-row>
              </mat-expansion-panel>
            </div>
          </div>
        </mat-accordion>
      </div>
      <div *ngIf="area.area_IsOption">
        <div *ngFor="let areaOptionGroup of area.quoteAreaOptionGroups">
          <div class="row">
            <span *ngIf="areaOptionGroup.optionGroup === null; then ungroupedOptionBlock; else groupOptionBlock"></span>
            <ng-template #ungroupedOptionBlock>
              <h5 class="mb-0">
                {{area.area_Name}}
              </h5>
            </ng-template>
            <ng-template #groupOptionBlock>
              <h5>{{area.area_Name}} - Group {{areaOptionGroup.optionGroup}}</h5>
            </ng-template>
            <div *ngIf="showLinePricing" class="float-right mr-5">
              <div colspan="5"></div>
              <div><h5><span i18n>Total</span> ${{areaOptionGroup.totalCost | number: '1.2-2'}}</h5></div>
            </div>
          </div>
          <mat-accordion>
            <div cdkDropList [cdkDropListData]="areaOptionGroup.optionGroup" (cdkDropListDropped)="dropItem($event)">
              <div cdkDrag class="text-bidit-primary" *ngFor="let lineItem of areaOptionGroup.quoteAreaItems">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <div class="col-6">
                      <div id="lineItem.subArea.subArea_Name">{{lineItem.subArea.subArea_Name}} <span *ngIf="lineItem.area_Name"> - {{lineItem.area_Name}}</span></div>
                    </div>
                    <div class="col-6">
                      <div class="col">
                        <label i18n>Square Ftg:</label>
                        <span>{{lineItem.area_SqrFtg | number: '1.2' }}</span>
                      </div>
                      <div *ngIf="showLinePricing" class="col">
                        <label *ngIf="area.area_IsOption; else defaultHeader" i18n>Cost Change:</label>
                        <ng-template>
                          <label i18n>Cost:</label>
                        </ng-template>
                        <span>${{lineItem.area_TotalCost | number: '1.2' }}</span>
                      </div>
                    </div>
                  </mat-expansion-panel-header>
                  <div *ngIf="lineItem.item" class="row mt-3">
                    <div class="col-md-6">
                      {{lineItem.item.item_Name}}
                    </div>
                    <div class="col-md-6">
                      <div class="col">
                        <label class="mr-2">R-Value: </label>
                        <span *ngIf="lineItem.itemUsage; then usageBlock; else rValueBlock"></span>
                        <ng-template #usageBlock>{{lineItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                        <ng-template #rValueBlock>
                          <span *ngIf="lineItem.item && lineItem.item.rValue">{{lineItem.item.rValue.rValue_Desc}}</span>
                        </ng-template>
                      </div>
                      <div class="col">
                        <div *ngIf="area.area_IsOption && showLinePricing; else defaultAccessoryBlock">
                          <div showLinePricing>
                            <label class="mr-2" i18n>Estimate Change:</label>
                            <span>
                              ${{lineItem.optionBid | number: '1.2' }}
                            </span>
                          </div>
                          <div></div>
                        </div>                        
                        <ng-template #defaultAccessoryBlock>
                          <label class="mr-2" i18n>Addl Items:</label>
                          <span>
                            {{lineItem.accessories.length}}
                          </span>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <mat-action-row class="float-right mb-3">
                    <button *ngIf="!readOnly" class="btn btn-bidit-edit" (click)="openAreaDialog(lineItem.quoteAreaItem_ID)"></button>
                    <button *ngIf="!readOnly" class="btn btn-bidit-delete" (click)="deleteArea(lineItem.quoteAreaItem_ID)"></button>
                  </mat-action-row>
                </mat-expansion-panel>
              </div>
            </div>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
  <div class="col">
    <div *ngIf="showCostBreakdown" class="cost-breakdown-pnl">
      <h5 align="center" i18n>COST BREAKDOWN</h5>
      <table class="table table-bidit">
        <tbody>
          <tr>
            <td i18n>Material Cost:</td>
            <td>${{quote.materialCost | number: '1.2'}} ({{100 * quote.materialCost / quote.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Labor Cost:</td>
            <td>${{quote.laborCost | number: '1.2'}} ({{100 * quote.laborCost / quote.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Other Cost:</td>
            <td>${{quote.otherCost | number: '1.2'}} ({{100 * quote.otherCost / quote.totalCost | number: '1.2-2'}}%)</td>
          </tr>
          <tr>
            <td i18n>Total Cost:</td>
            <td>${{quote.totalCost | number: '1.2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="estimate-pnl">
      <h5 align="center" i18n>ESTIMATE</h5>
      <table class="table table-bidit">
        <tbody>
          <tr *ngIf="showLinePricing">
            <td i18n>Total Cost:</td>
            <td>${{quote.totalCost | number: '1.2'}}</td>
          </tr>
          <tr *ngIf="showMargins">
            <td i18n>Gross Margin:</td>
            <td>
              <div *ngIf="showMarginEdit==false">
                <a *ngIf="!readOnly" class="float-left" href="javascript:void(0);" (click)="editMargin()" i18n>Edit</a>

                <span class="float-right">{{quote.quote_GrossMargin | number: '1.0-4'}}%</span>
              </div>
              <div *ngIf="showMarginEdit" class="form-group" id="showMargin">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-danger form-control" (click)="updateQuoteMargin()" i18n>Update</button>
                </div>
                <input name="quote_GrossMargin" type="number" id="quote_GrossMargin" class="form-control"
                       [(ngModel)]="quote.quote_GrossMargin" #quote_GrossMargin="ngModel" />
              </div>
            </td>
          </tr>
          <tr *ngIf="showLinePricing" >
            <td i18n>Bid Subtotal:</td>
            <td>
              <div *ngIf="showBidAmountEdit==false">
                <a *ngIf="!readOnly" href="javascript:void(0);" (click)="editBid()" i18n>Edit</a>
                <span class="float-right">${{quote.quote_BidAmount | number: '1.2-2'}}</span>
              </div>

              <div *ngIf="showBidAmountEdit" class="input-group input-group-sm" id="show">
                <div class="input-group-prepend">
                  <button class="btn btn-outline-danger form-control" name="editAmount" value="editAmount" (click)="updateBidAmount()" i18n>Update</button>
                </div>
                <input name="quote_BidAmount" id="quote_BidAmount" type="text" class="form-control"
                       style="text-align:right;"
                       [(ngModel)]="quote.quote_BidAmount" #quote_BidAmount="ngModel">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <button *ngIf="!readOnly" (click)="openQuoteTaxDialog()" class="btn btn-bidit-navigate btn-md" i18n>Edit Tax</button>
              <label *ngIf="readOnly" i18n>Tax Amount:</label>
            </td>
            <td>${{quote.netTax_Total ?? 0 | number: '1.2-2'}}</td>
          </tr>
          <tr>
            <td i18n>Bid Total:</td>
            <td>${{quoteBidTotalAmount | number: '1.2-2'}}</td>
          </tr>
          <tr *ngIf="showMargins">
            <td i18n>Margin Dollars:</td>
            <td>${{quoteMarginAmount | number: '1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <app-spinner [isRunning]="isRequesting"></app-spinner>
</div>

<div *ngIf="!quote.quote_IsTemplate" class="row" align="center">
  <div class="col-12" *ngIf="!isRequesting">
    <button *ngIf="!isRequesting && !quoteOnly && allowPrint" (click)="openPrintOptionsDialog()" class="btn btn-bidit-action mr-1" i18n>Print</button>
    <button *ngIf="!isRequesting && allowPrint" (click)="openEmailDialog()" class="btn btn-bidit-action" i18n>Send</button>
    <button (click)="acknowledgeQuote(2)" *ngIf="quote.acknowledgementStatus == 'Pending' || quote.acknowledgementStatus == 'Accepted'" class="ml-1 btn btn-bidit-action" onclick="this.blur();" i18n>Reject</button>
  </div>
  <app-spinner [isRunning]="isRequesting"></app-spinner>
</div>
<div *ngIf="quote.quote_IsTemplate" class="row">
  <div class=" col-sm-9">
    <button (click)="returnToAdmin()" class="btn btn-bidit-submit float-right" i18n>Done</button>
  </div>
</div>

